import { Token, Currency } from '@donaswap/swap-sdk-core'
import { WNATIVE, Native } from '@donaswap/sdk'

export function unwrappedToken(token: Token): Currency {
  if (token && token.equals(WNATIVE[token.chainId])) return Native.onChain(token.chainId)
  return token
}
